import { ColDef } from '@ag-grid-enterprise/all-modules'
import i18n from '@/lang/i18n'
import { initialCrudModelBaseState, CrudModelPaginatorLaboratory } from '@/shared/models/cruds.models'
import { AgGridColumnType } from '@/shared/models/ag-grid.model'
import { PaginatorLaboratoryDatasource } from '@/shared/resources/datasources/paginator/paginator-laboratory-datasource'
import { configurationInsurerService } from '@/modules/configurationModule/detail/cases/insurers/services/configuration-insurer.service'
import { ConfigurationInsurerResponse } from '@/modules/configurationModule/detail/cases/insurers/services/configuration-insurer.dto'
import { store } from '@/store/store'

export const columnsDefInsurersGrid =
    (): ColDef[] => [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.insurer'),
            field: 'name',
            minWidth: 250,
            suppressSizeToFit: true,
            sortable: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.grid.code'),
            field: 'code',
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true,
            sortable: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.grid.email'),
            field: 'email',
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true,
            sortable: true
        },
        {
            type: AgGridColumnType.CHECK_ICON,
            headerName: i18n.tc('configuration.grid.sendingAuthorizations'),
            field: 'sendAuthorizations',
            minWidth: 80,
            suppressSizeToFit: true,
            sortable: true
        },
        {
            type: AgGridColumnType.CHECK_ICON,
            headerName: i18n.tc('configuration.modal.systemBadge'),
            field: 'system',
            minWidth: 80,
            suppressSizeToFit: true,
            sortable: true
        },
        {
            type: AgGridColumnType.CHECK_ICON,
            headerName: i18n.tc('configuration.grid.active'),
            field: 'active',
            minWidth: 80,
            suppressSizeToFit: true,
            sortable: true
        }
    ]

export interface InsurersGridState extends CrudModelPaginatorLaboratory<ConfigurationInsurerResponse> {
    service: typeof configurationInsurerService
    laboratoryId: number
    sidepanelTitle: string
}
export const initialInsurersGridState =
    (): InsurersGridState => ({
        ...initialCrudModelBaseState(),
        gridUiComponent: 'uicomponent.configuration.global.cases.insurers',
        columnsDef: columnsDefInsurersGrid(),
        datasource: new PaginatorLaboratoryDatasource(configurationInsurerService, store.getters.labId),
        service: configurationInsurerService,
        laboratoryId: store.getters.labId,
        sidepanelTitle: ''
    })
